<template>
  <div
    class="onestop-company supervisor-info-view"
    :class="{ 'clear-header': isWechatBrowser }"
  >
    <my-header
      title="整包公司"
      v-if="!isWechatBrowser"
      :showBack="true"
    ></my-header>
    <div class="company-detail">
      <div class="name"></div>
      <div class="company-auth">
        <div class="top">
          <img :src="imgUrl + companyInfo.logo" />
          <div class="base-info">
            <div class="top">
              {{ companyInfo.name }}
              <img
                class="platform"
                src="../../assets/icon-platform-company.png"
              />
            </div>
            <div class="tag-list">
              <div class="tag-item">
                {{ companyInfo.constructionGuarantee }}年施工质保
              </div>
              <div class="line"></div>
              <div class="tag-item">
                {{ companyInfo.hydropowerGuarantee }}年水电质保
              </div>
              <div class="line"></div>
              <div class="tag-item">
                {{ companyInfo.waterproofGuarantee }}年卫生间质保
              </div>
            </div>
          </div>
        </div>
        <div class="management" v-if="companyInfo.management">
          <span class="label">主营：</span>
          <span class="info">{{ companyInfo.management }}</span>
        </div>
      </div>
    </div>
    <div v-if="adList.length > 0">
      <img
        v-if="ad.relationId"
        style="width: 6.9rem;height: 1.3rem;margin: 0.3rem auto 0;display: block"
        v-for="ad in adList"
        @click="toArticleDetail(ad.relationId, '', '')"
        :src="imgUrl + ad.attachment"
      />
      <img
        v-if="!ad.relationId"
        style="width: 6.9rem;height: 1.3rem;margin: 0.3rem auto 0;display: block"
        v-for="ad in adList"
        :src="imgUrl + ad.attachment"
      />
    </div>
    <div v-if="onestopCaseList.length > 0">
      <div class="section-title">套餐服务</div>
      <div class="case-list">
        <div
          class="case-item"
          v-for="onestopCase in onestopCaseList"
          @click="
            openOnestopCaseDetail(
              onestopCase.id,
              onestopCase.title,
              onestopCase.price,
              onestopCase.companyId
            )
          "
        >
          <div class="info">
            <img :src="imgUrl + onestopCase.cover" />
            <div class="title">{{ onestopCase.title }}</div>
            <div v-if="onestopCase.price > 0" class="price">
              <span class="unit">￥</span
              ><span class="num">{{ onestopCase.price }}</span
              ><span class="unit">/㎡</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="supervisor-detail-tab">
      <div
        class="tab-item"
        @click="isLabel(0)"
        :class="{ selected: isLabelNum == 0 }"
      >
        企业简介
      </div>
      <div
        class="tab-item"
        @click="isLabel(3)"
        :class="{ selected: isLabelNum == 3 }"
      >
        精选案例
      </div>
      <div
        class="tab-item"
        @click="isLabel(2)"
        :class="{ selected: isLabelNum == 2 }"
      >
        装修评价
      </div>
    </div>
    <div class="intro" v-if="isLabelNum == 0">
      <div class="content" v-if="companyInfo.intro">
        {{ companyInfo.intro }}
      </div>
      <div
        v-if="companyInfo.companyIntro"
        v-html="companyInfo.companyIntro"
      ></div>
      <div v-if="!companyInfo.intro" class="black-page">
        <img src="../../assets/icon-no-img.png" />
        <div class="tip">该整包公司还没有自述哦!</div>
      </div>
    </div>
    <div class="project-list" v-if="isLabelNum == 1">
      <div
        class="project-item"
        v-for="(caseProject, index) in caseList"
        v-if="index < 3"
        @click="openCaseProject(caseProject)"
      >
        <img
          v-if="caseProject.onestopProject.cover"
          :src="
            (imgUrl + caseProject.onestopProject.cover) | ossProcess(690, 320)
          "
        />
        <img
          v-if="!caseProject.onestopProject.cover"
          src="../../assets/icon-supervisor-case-cover.png"
        />
        <div class="project-info">
          <div class="name">{{ caseProject.onestopProjectName }}</div>
          <div>{{ caseProject.onestopProject.houseLayout }}</div>
        </div>
        <div class="project-evaluate">
          <div v-if="caseProject.status == '4'" class="project-status">
            施工中
          </div>
          <div v-if="caseProject.status == '5'" class="project-status">
            验收中
          </div>
          <div v-if="caseProject.status == '6'" class="project-status">
            已完工
          </div>
        </div>
      </div>
      <div
        class="loading-more"
        v-if="caseList.length > 3"
        @click="openCaseList()"
      >
        <span>查看其余{{ caseList.length - 3 }}个</span>
      </div>
      <div v-if="caseList.length == 0" class="black-page">
        <img src="../../assets/icon-no-img.png" />
        <div class="tip">暂无该公司的相关案例!</div>
      </div>
    </div>
    <div class="project-list" v-if="isLabelNum == 3">
      <div
        class="project-item"
        v-for="article in articleList"
        @click="openArticle(article)"
      >
        <img v-if="article.cover" :src="imgUrl + article.cover" class="cover" />
        <img v-else="" src="../../assets/icon-project-default-cover.png" />
        <div class="project-info">
          <div class="name">{{ article.title }}</div>
        </div>
      </div>
      <div v-if="articleList.length == 0" class="black-page">
        <img src="../../assets/icon-no-img.png" />
        <div class="tip">暂无相关案例</div>
      </div>
    </div>
    <CompanyEvaluateList :company-id="companyId" v-if="isLabelNum == 2" />
    <div
      class="btn-order"
      @click="openOnestopReservation(companyInfo.id, companyInfo.deposit)"
    >
      预 约
    </div>
  </div>
</template>

<script>
import { imgUrl, shareIcon } from "../../config";
import { Toast } from "mint-ui";
import Header from "../../components/header/Header";
import CompanyService from "../../service/company/CompanyService";
import CmsArticleService from "../../service/article/ArticleService";
import shareService from "../../service/share/ShareService";
import onestopProjectSupervisorService from "../../service/onestop/OnestopProjectSupervisorService";
import EvaluateService from "../../service/customer/EvaluateService";
import OnestopProjectService from "../../service/onestop/OnestopProjectService";
import caseArticleService from "../../service/onestop/OnestopCaseArticleService";
import session from "../../utils/Session";
import CompanyEvaluateList from "./components/CompanyEvaluateList";

export default {
  name: "OnestopDetail",
  components: {
    CompanyEvaluateList,
    "my-header": Header,
  },
  data() {
    return {
      imgUrl: imgUrl,
      shareIcon: shareIcon,
      companyInfo: { tagList: [] },
      onestopProjectCaseList: [],
      articleList: [],
      subCategoryId: 18,
      isWechatBrowser: this.$verfyBrowserType(),
      companyId: "",
      isLabelNum: 0,
      caseList: [],
      customerEvaluateList: [],
      type: "2",
      onestopCaseList: [],
      adList: [],
    };
  },
  created() {
    this.companyId = this.$route.query.companyId;
  },
  beforeMount() {
    document.title = this.$route.meta.title;
    this.getCompanyInfo();
    this.getOnestopCaseList();
    this.initWechatShare();
  },
  methods: {
    isLabel(num) {
      if (num == 0) {
        this.isLabelNum = 0;
      } else if (num == 2) {
        this.isLabelNum = 2;
      } else if (num == 3) {
        this.isLabelNum = 3;
        this.getCaseArticleList();
      }
    },
    async getCompanyInfo() {
      let { code, msg, data } = await CompanyService.getCompanyInfo(
        this.companyId
      );
      if (code == 0) {
        this.companyInfo = data.company;
        this.adList = data.adList;
      } else {
        Toast("获取整包公司信息失败");
      }
    },
    async getCaseArticleList() {
      let { code, data } = await caseArticleService.getList("", this.companyId);
      if (code == 0) {
        this.articleList = data;
      } else {
        Toast("获取案例信息失败");
      }
    },
    async openOnestopReservation(companyId, deposit) {
      if (!!this.global.isMiniProgrm) {
        session.isLogin().then((flag) => {
          if (flag) {
            wx.miniProgram.navigateTo({
              url: `/pages/onestop/reservation/reservation?companyId=${companyId}&deposit=${deposit}`,
            });
          } else {
            let backUrl = this.$route.fullPath;
            wx.miniProgram.navigateTo({
              url: `/pages/register/register?h5Url=${encodeURIComponent(
                backUrl
              )}`,
            });
          }
        });
      } else {
        this.$router.push({
          name: "OnestopReservation",
          query: { companyId, deposit },
        });
      }
    },
    //跳转文章详情
    toArticleDetail(id, title, summary) {
      this.$router.push({
        name: "ArticleDetail",
        query: { articleId: id, title, summary },
      });
    },
    openArticle(article) {
      this.$router.push({
        name: "ArticleDetail",
        query: {
          articleId: article.articleId,
          title: article.title,
          summary: "",
        },
      });
    },
    async getProjectList() {
      var result = await onestopProjectSupervisorService.list(
        "",
        "",
        1,
        this.companyId
      );
      if (result.code == 0) {
        this.caseList = [];
        for (let caseProject of result.data.result) {
          if (caseProject.status != 7) {
            this.caseList.push(caseProject);
          }
        }
      } else {
        Toast("获取监理案例信息失败");
      }
    },
    openCaseList() {
      Toast("该功能正在实现中,请耐心等待");
    },
    openCaseProject(project) {
      this.$router.push({
        name: "OnestopProjectDetail",
        query: {
          id: project.customerProjectId,
          onestopProjectId: project.projectId,
          companyId: this.companyId,
          type: project.type,
          projectName: project.name,
        },
      });
    },
    async getArticleList() {
      let {
        code,
        data: { result },
      } = await CmsArticleService.list(this.subCategoryId);
      if (code == 0) {
        this.articleList = result;
        console.info("this.articleList", this.articleList);
      } else {
        Toast("获取装修案例信息失败");
      }
    },
    openOnestopCaseDetail(id, caseTitle, casePrice, companyId) {
      this.$router.push({
        name: "OnestopCompanyDetail",
        query: { id, caseTitle, casePrice, companyId },
      });
    },
    async getOnestopCaseList() {
      var result = await OnestopProjectService.getOnestopCaseList(
        this.companyId
      );
      if (result.code == 0) {
        this.onestopCaseList = result.data;
        for (let onestopCase of this.onestopCaseList) {
          if (onestopCase.title.length > 12) {
            onestopCase.title = onestopCase.title.substring(0, 12) + "...";
          }
        }
      } else {
        Toast("获取装修套餐信息失败");
      }
    },
    async initWechatShare() {
      let title = "吉客家装"; // 分享标题
      let desc =
        "吉客家装——以“包工包料、包主材包辅料”的整装全包模式，搭配监理与业主一对一监理服务，颠覆传统家装模式，解决装修痛点"; // 分享描述
      let link = window.location.href; // 分享链接
      link = link.replace(/#/, "?#");
      await shareService.wechatShare(title, desc, link, this.shareIcon);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/style/supervisor-detail.scss";
@import "../../assets/style/common.scss";
.btn-part {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.66rem;
  background-color: #ffffff;
}
.btn-order {
  position: fixed;
  bottom: 0.3rem;
  left: 0.35rem;
  width: 6.8rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  background: #00478e;
  color: white;
  font-size: 0.34rem;
  border-radius: 0.14rem;
}
.onestop-company {
  padding-bottom: 1.8rem;
  background: white;
  color: #333;
  font-size: 0.3rem;
  .clear-header {
    margin-top: -1rem;
  }
  .company-detail .name {
    width: 100%;
    padding: 0.8rem 0.33rem 1.2rem;
    background: #c4a183;
    color: white;
    font-size: 0.42rem;
    font-weight: bold;
  }
  .no-msg {
    background: white;
    color: #878e99;
    font-size: 0.28rem;
    text-align: center;
    padding-top: 1rem;
    img {
      width: 1.5rem;
      margin-bottom: 0.5rem;
    }
  }
  .case-list {
    display: flex;
    margin-top: 0.2rem;
    column-gap: 0.2rem;
    padding-left: 0.25rem;
    border-bottom: solid 0.2rem #f8f8f8;
    width: 100%;

    .case-item {
      width: 2rem;
      margin-left: 0.14rem;
      .info {
        font-size: 0.34rem;
        color: #333;
        img {
          width: 2rem;
          height: 2rem;
          border-radius: 0.1rem;
          display: block;
        }
      }
      .title {
        margin-top: 0.1rem;
        font-weight: bold;
      }
      .price {
        margin-top: 0.1rem;
        color: #e07070;
        .unit {
          font-size: 0.3rem;
        }
        .num {
          margin-right: 0.06rem;
          font-size: 0.32rem;
          font-weight: bold;
        }
      }
    }
  }
  .company-auth {
    width: 6.3rem;
    padding: 0.4rem 0.2rem;
    margin: -1.5rem auto 0.1rem;
    background-color: #f8f7f3;
    border-radius: 0.1rem;
    font-size: 0.3rem;
    color: #333;
    .top {
      display: flex;
    }
    img {
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 1.3rem;
    }
    .base-info {
      width: 5.4rem;
      .top {
        margin-top: 0.14rem;
        margin-left: 0.3rem;
        font-size: 0.34rem;
        color: #333;
        font-weight: bold;
      }
      .platform {
        margin-top: -5px;
        margin-left: 8px;
        width: 80px;
        height: 33px;
        border-radius: 0;
      }
      .tag-list {
        width: 4.6rem;
        height: 0.6rem;
        line-height: 0.6rem;
        margin-top: 0.11rem;
        margin-left: 0.24rem;
        padding: 0rem 0.1rem;
        display: flex;
        justify-content: space-between;
        background-color: #efebe5;
        border-radius: 0.1rem;
        color: #9d704a;
        font-size: 0.23rem;
        .tag-item {
          white-space: nowrap;
        }
        .line {
          width: 1px;
          height: 0.24rem;
          margin-top: 0.2rem;
          background-color: #9d704a;
        }
      }
      .label {
        font-size: 0.28rem;
        color: #7f7d7c;
      }
    }
    .management {
      margin-top: 0.3rem;
      font-size: 0.3rem;
      .label {
        color: #999999;
      }
    }
  }
}
</style>
